<div class="job-grid">
  <div class="expanded" [ngClass]="expanded" id="jobsList">
    <div class="job-header-main">
      <h1>Job Openings</h1>
      <p class="job-header-main-subtitle">Showing {{ jobs?.length }} of {{ totalJobs }} Jobs</p>
    </div>
    <agile-jobs-filter
      [locations]="locations"
      [categories]="categories"
      [jobTypes]="jobTypes"
      [clearances]="clearances"
      [availability]="availability"
    ></agile-jobs-filter>
    <mat-progress-bar mode="indeterminate" *ngIf="jobsService.loading || loading"></mat-progress-bar>

    <div *ngIf="jobs?.length" class="job-list" (scroll)="handleScroll($event)">
      <agile-job-card *ngFor="let job of jobs" [job]="job"> </agile-job-card>

      <!-- Structured Data for Google -->
      <script type="application/ld+json" *ngFor="let job of jobs">
        {{
          {
            "@context": "https://schema.org",
            "@type": "JobPosting",
            "title": job?.publishable_title,
            "description": job?.description_publishable || "No description available.",
            "datePosted": job?.published_date,
            "validThrough": new Date(new Date().setDate(new Date().getDate() + 30)).toISOString(),
            "employmentType": job?.type === 'Full-Time' ? "FULL_TIME" : "PART_TIME",
            "hiringOrganization": {
              "@type": "Organization",
              "name": job?.Company?.name,
              "logo": job?.Company?.logo,
              "sameAs": job?.Company?.subdomain === 'lis'
                ? `https://${job.Company.subdomain}-careers.services.agileonboarding.com/jobs`
                : `https://${job.Company.subdomain}-jobs.services.agileonboarding.com/jobs`
            },
            "jobLocation": {
              "@type": "Place",
              "address": {
                "@type": "PostalAddress",
                "addressLocality": job?.city,
                "addressRegion": job?.state,
                "addressCountry": job?.country
              }
            },
            "baseSalary": {
              "@type": "MonetaryAmount",
              "currency": "USD",
              "value": {
                "@type": "QuantitativeValue",
                "value": job?.target_salary,
                "unitText": "YEAR"
              }
            }
          } | json
        }}
      </script>
    </div>
    <div *ngIf="!jobs?.length && !loading" class="no-jobs-text">
      <p>Thank you for your interest in joining {{ jobsService.company?.name }}</p>
      <p>Unfortunately, we do not have any job openings at the moment. Please check back again later.</p>
    </div>
  </div>
</div>
